export function getCards(state) {
  return state.cards;
}

export function getCardId(state, getters) {
  return Number(getters.getRouteParams.cardId);
}

export function getCard(state, getters) {
  return state.cards[getters.getCardId] || {};
}

export function getAssignedCard(state, getters) {
  return getters.getCard && getters.getCard.assigned_card;
}

export function getGradeName(state, getters) {
  return getters.getAssignedCard && getters.getAssignedCard.grade_name;
}

export function getSubjectName(state, getters) {
  return getters.getAssignedCard && getters.getAssignedCard.subject_name;
}

export function getClassGrade(state, getters) {
  return getters.getCard.assigned_class && getters.getCard.assigned_class.grade;
}

export function getClassName(state, getters) {
  return getters.getCard.assigned_class && getters.getCard.assigned_class.name;
}

export function getSchoolName(state, getters) {
  return getters.getCard.assigned_class && getters.getCard.assigned_class.school_name;
}

export function getTeacherName(state, getters) {
  return getters.getCard && getters.getCard.assigned_by_name;
}

export function getTeacherProfileImage(state, getters) {
  return getters.getCard && getters.getCard.assigned_by_profile_image;
}

export function getCoreConcept(state) {
  return state.coreConcept || {};
}

export function getDomainName(state, getters) {
  return getters.getCoreConcept.domain && getters.getCoreConcept.domain.name;
}

export function getDomainId(state, getters) {
  return getters.getCoreConcept.domain && getters.getCoreConcept.domain.id;
}

export function getChapterName(state, getters) {
  return getters.getAssignedCard && getters.getAssignedCard.chapter_name;
}
